// Nothing is imported from './featureVisibility' any more: both gates below
// return a hard false, and CRA fails a CI build on an unused import. Both
// resume paths need devOnly() or visibleExceptProd() back from there.

/**
 * Single switch for the photographed-report import review: the confirmation
 * screen the practitioner approves before a vision-read lab report becomes
 * values on the test.
 *
 * ON HOLD as of 2026-08-24, and CLOSED EVERYWHERE since 2026-09-23, local dev
 * included.
 *
 * It works end to end: the bloodworkVision Lambda is deployed and behind an
 * authenticated API, and the screen reads real reports. It is held back as a
 * product decision rather than a technical one, so the gate closes rather than
 * anything being torn down.
 *
 * Why local dev went too, at the practitioner's request: this gate is not only
 * the multi-file picker. In handleLegacyUpload() it is also the AUTOMATIC
 * fallback — a PDF the free parser returns nothing usable for was handed
 * straight to the vision reader, with no offer and no click, at a model call
 * per page. So every empty parse while developing spent real money, which is
 * not a thing to leave switched on for the one audience that hits empty parses
 * on purpose. With it shut, an empty parse reports the "no readable text"
 * message instead, exactly as it does on slava and prod.
 *
 * Note it is now a hard false rather than devOnly(), for the same reason
 * unmappedMarkerScanVisible() below is: a developer sees what a practitioner
 * sees, and neither reader can be billed by accident.
 *
 * Fails closed without REACT_APP_VISION_LAMBDA_URL — see visionEnabled in
 * upload.tsx. A build that forgets the variable behaves exactly like today
 * rather than offering an import it cannot complete.
 *
 * Modeled on aiProgressSummaryVisible() and bwhLabsVisible(): a gate rather
 * than commented-out code, so the component, its types and the upload call site
 * keep compiling and cannot rot while the Lambda catches up.
 *
 * TO RESUME: return devOnly() for local only, visibleExceptProd() for slava, or
 * delete this function and its call sites to ship everywhere. Nothing else
 * needs changing. The read sits behind a Lambda Function URL that accepts both
 * the slava and prod Cognito pools, and scripts/deploy.js ships that URL to
 * every environment.
 */
export function importReviewVisible(): boolean {
  return false;
}


/**
 * The narrower half of that feature: the "Scan for markers LabSmarts doesn't
 * have" button offered after a PDF has been parsed for free.
 *
 * Separate from importReviewVisible() because it is a separate decision. The
 * photographed-report import is on hold; this is not, because it reads what no
 * parser can: a marker on a lab LabSmarts has no parser for, a qualitative
 * result, a row nobody has defined in My Markers yet.
 *
 * Held out of prod for now because it spends money per click, on a model call
 * per page. That is a decision to make deliberately rather than by shipping.
 *
 * Both gates read the same VISION_URL and the same onReviewImport in
 * upload.tsx, so either can be open without the other.
 *
 * CLOSED EVERYWHERE as of 2026-08-31, local dev included, at the practitioner's
 * request: the feature is not ready to ship and the button was visible on slava
 * while it sat behind visibleExceptProd(). Nothing is torn down, exactly as
 * with importReviewVisible() above — the button, the Lambda and the deep-scan
 * state all keep compiling.
 *
 * Worth knowing before reopening: this WAS the only path by which a marker
 * LabSmarts has no field for could reach a test, and since 2026-09-23 it is not.
 * The free parse hands back the rows no shipped marker took, and the app fills
 * whichever of them the practitioner has defined in My Markers (see
 * fillRowsFromImport in custom-markers-table.tsx). What this button still adds
 * over that is the rows nobody has defined yet, which is a different job. The two
 * upload failure paths that used to offer it now fall through to their own
 * messages instead, which is why they read sensibly with the gate shut.
 *
 * TO RESUME: return visibleExceptProd() for slava and local, or devOnly() for
 * local only. Nothing else needs changing.
 */
export function unmappedMarkerScanVisible(): boolean {
  return false;
}
